<template>
  <v-dialog v-model="isActive"
            :persistent="isPersistent"
            :scrim="scrim"
            @keydown.esc="cancelAndClose"
            width="500">
    <v-sheet class="pa-2">
      <v-sheet class="d-flex justify-end">
        <v-btn icon="mdi-close" @click="cancelAndClose" flat density="comfortable"></v-btn>
      </v-sheet>
      <v-sheet class="px-4">
        <span class="d-flex text-subtitle-1 font-weight-bold mx-2">{{ t('archive-scope-question') }}</span>
        <v-radio-group v-model="radios" color="primary" class="text-black" hide-details>
          <v-row no-gutters>
            <v-col v-for="scope in scopes" cols="6" class="mt-4">
              <v-radio :label="scope.label" :value="scope.id" :disabled="scope.admin?!userStore.isAdmin:false"
                       :class="['border  rounded-sm py-1 mx-2',radios==scope.id?'border-primary border-opacity-100':'']"></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>
        <v-checkbox :label="t('archive-with')" v-model="withArchive" color="orange-darken-3"
                    class="d-flex justify-end px-2"></v-checkbox>
        <v-sheet v-if="radios.valueOf()!=='store'" class="d-flex flex-row pa-2 align-center">
          <span class="me-auto ">{{ t('archive.last-update') }}</span>
            <v-text-field
                density="compact"
                variant="outlined"
                :ripple="false"
                :loading="loading"
                append-inner-icon="mdi-calendar"
                readonly
                color="primary"
                max-width="150px"
                hide-details>
              {{ new Date(selectedDate).toLocaleDateString($i18n.locale) }}
              <v-menu v-model="isOpen" :close-on-content-click="false" activator="parent" location="right center"
                      offset="10">
                <v-date-picker v-model="selectedDate"
                               @update:model-value="isOpen = false"
                               elevation="1"
                               title=""
                               :header="t('choose-date-title')"
                               color="primary"
                               show-adjacent-months/>
              </v-menu>
            </v-text-field>
        </v-sheet>
        <v-sheet v-if="withArchive" rounded
                 class="d-flex flex-row mx-2  pa-2 border-md border-opacity-100 bg-orange-lighten-5  border-warning">
          <v-icon icon="mdi-alert-circle-outline" color="orange-darken-3"/>
          <div class="ml-2 text-subtitle-2 text-justify text-orange-darken-3">
            {{ t('archive.warning.begin') }}<span
              v-if="radios!='store'" class="font-weight-bold">{{
              t('archive.part-' + radios)
            }}</span>{{ t('archive.warning.end') }}<span class="text-decoration-underline">Diagnostic > {{
              t('historic-diag')
            }}</span>
          </div>
        </v-sheet>
        <v-sheet v-else rounded
                 class="d-flex flex-row mx-2  pa-2 border-md border-opacity-100 bg-red-lighten-5 border-error">
          <v-icon icon="mdi-alert-outline" color="red-darken-3"/>
          <div class="ml-2 text-subtitle-2 text-justify text-red-darken-3">
            <span class="font-weight-bold">{{ t('archive.error.begin-1') }}</span><span>{{
              t('archive.error.begin-2')
            }}</span><span
              v-if="radios!='store'" class="font-weight-bold">{{
              t('archive.part-' + radios)
            }}</span>{{ t('archive.error.end') }}
          </div>
        </v-sheet>

        <v-sheet class="pa-4">
          <v-row>
            <v-col offset="1" cols="5" class="d-flex">
              <v-btn @click="cancelAndClose" variant="text" border size="large"
                     class="flex-grow-1 text-none text-body-1 font-weight-bold"
                     color="primary">
                {{ t('cancel') }}
              </v-btn>
            </v-col>
            <v-col cols="5" class="d-flex">
              <v-btn color="primary"
                     :loading="loading"
                     data-cy="confirm-button"
                     @click="onConfirmClick"
                     size="large"
                     flat class="flex-grow-1 text-none text-body-1 font-weight-bold">
                {{ t('confirm') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
      </v-sheet>
    </v-sheet>

  </v-dialog>
</template>
<script setup lang="ts">

import type {ToastType} from "~/composables/openToast";
import {useI18n} from "vue-i18n";

const {t} = useI18n()
export type ReturnDialogValue = { toastType: ToastType }
export type Scope = { id: string, label: string, admin: boolean }
const loading = ref(false)
const withArchive = ref(true)
const userStore = useUserStore()
const diagnosticStore = useDiagnosticStore()
const decathStore = useDecathlonStores()
const scopes = ref<Scope[]>([
  {id: 'store', label: t('store'), admin: false},
  {id: 'region', label: 'Region', admin: true},
  {id: 'country', label: t('country'), admin: true},
  ...(decathStore.selectedCrossDiag?.countryScope === 'UNITED') ? [{id: 'world', label: 'United', admin: true}] : [],
])
const isActive = ref(true)
const radios = ref('store')
const isOpen = ref(false)
const selectedDate = ref(new Date())

const {close} = defineProps<{
  close: (value: ReturnDialogValue) => void
  isPersistent: boolean
  scrim: boolean
}>()

const onConfirmClick = async () => {
  loading.value = true
  let result
  result = await diagnosticStore.resetDiagnostic(radios.value, withArchive.value, selectedDate.value)
  await diagnosticStore.fetchDiagnosticByStore()
  loading.value = false
  close({toastType: result ? 'success' : 'error'})
}
const cancelAndClose = () => close({toastType: 'canceled'})

</script>

